/*https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/every*/
if ( !Array.prototype.every ) {
     Array.prototype.every = function ( callbackfn, thisArg ) {
          'use strict';
          var T, k;
          if ( this == null ) {
               throw new TypeError( 'this is null or not defined' );
          }
          var O = Object( this );
          var len = O.length >>> 0;
          if ( typeof callbackfn !== 'function' ) {
               throw new TypeError();
          }
          if ( arguments.length > 1 ) {
               T = thisArg;
          }
          k = 0;
          while ( k < len ) {
               var kValue;
               if ( k in O ) {
                    kValue = O[ k ];
                    var testResult = callbackfn.call( T, kValue, k, O );
                    if ( !testResult ) {
                         return false;
                    }
               }
               k++;
          }
          return true;
     };
}

/*https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter*/
if ( !Array.prototype.filter )
     Array.prototype.filter = function ( func, thisArg ) {
          'use strict';
          if ( !( ( typeof func === 'Function' || typeof func === 'function' ) && this ) )
               throw new TypeError();
          var len = this.length >>> 0,
               res = new Array( len ),
               t = this,
               c = 0,
               i = -1;
          if ( thisArg === undefined )
               while ( ++i !== len )
                    if ( i in this )
                         if ( func( t[ i ], i, t ) )
                              res[ c++ ] = t[ i ];
                         else
                              while ( ++i !== len )
                                   if ( i in this )
                                        if ( func.call( thisArg, t[ i ], i, t ) )
                                             res[ c++ ] = t[ i ];
          res.length = c;
          return res;
     };

/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
* Production steps of ECMA-262, Edition 5, 15.4.4.18
* Reference: http://es5.github.io/#x15.4.4.18
*/
if ( !Array.prototype.forEach ) {
     Array.prototype.forEach = function ( callback /*, thisArg*/ ) {
          'use strict';
          var T, k;
          if ( this == null ) {
               throw new TypeError( 'this is null or not defined' );
          }
          var O = Object( this );
          var len = O.length >>> 0;
          if ( typeof callback !== 'function' ) {
               throw new TypeError( callback + ' is not a function' );
          }
          if ( arguments.length > 1 ) {
               T = arguments[ 1 ];
          }
          k = 0;
          while ( k < len ) {
               var kValue;
               if ( k in O ) {
                    kValue = O[ k ];
                    callback.call( T, kValue, k, O );
               }
               k++;
          }
     };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
/*
 * array.includes polyfill
 */
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (searchElement, fromIndex) {

            if (this == null) throw new TypeError('"this" is null or not defined');

            var o = Object(this);
            var len = o.length >>> 0;

            if (len === 0) return false;

            var n = fromIndex | 0;
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            while (k < len) {
                if (sameValueZero(o[k], searchElement)) return true;
                k++;
            }

            return false;
        }
    });
}
 /* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility*/
 if ( !Array.prototype.indexOf ) {
      Array.prototype.indexOf = function ( vMember, nStartFrom ) {
           'use strict';
           if ( this == null ) {
                throw new TypeError( "Array.prototype.indexOf() - can't convert `" + this + "` to object" );
           }
           var nIdx = isFinite( nStartFrom ) ? Math.floor( nStartFrom ) : 0,
                oThis = this instanceof Object ? this : new Object( this ),
                nLen = isFinite( oThis.length ) ? Math.floor( oThis.length ) : 0;

           if ( nIdx >= nLen ) {
                return -1;
           }

           if ( nIdx < 0 ) {
                nIdx = Math.max( nLen + nIdx, 0 );
           }

           if ( vMember === undefined ) {
                do {
                     if ( nIdx in oThis && oThis[ nIdx ] === undefined ) {
                          return nIdx;
                     }
                } while ( ++nIdx < nLen );
           } else {
                do {
                     if ( oThis[ nIdx ] === vMember ) {
                          return nIdx;
                     }
                } while ( ++nIdx < nLen );
           }
           return -1;
      };
 }

 /* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
  * Production steps of ECMA-262, Edition 5, 15.4.4.19
  * Reference: http://es5.github.io/#x15.4.4.19
  */
 if ( !Array.prototype.map ) {
      Array.prototype.map = function ( callback /*, thisArg*/ ) {
           'use strict';
           var T, A, k;
           if ( this == null ) {
                throw new TypeError( 'this is null or not defined' );
           }
           var O = Object( this );
           var len = O.length >>> 0;
           if ( typeof callback !== 'function' ) {
                throw new TypeError( callback + ' is not a function' );
           }
           if ( arguments.length > 1 ) {
                T = arguments[ 1 ];
           }

           A = new Array( len );
           k = 0;
           while ( k < len ) {

                var kValue, mappedValue;
                if ( k in O ) {
                     kValue = O[ k ];
                     mappedValue = callback.call( T, kValue, k, O );
                     A[ k ] = mappedValue;
                }
                k++;
           }
           return A;
      };
 }

/*! loadCSS. [c]2017 Filament Group, Inc. MIT License */
/*
https://github.com/filamentgroup/loadCSS/blob/master/src/cssrelpreload.jsThis file is meant as a standalone workflow for
- testing support for link[rel=preload]
- enabling async CSS loading in browsers that do not support rel=preload
- applying rel preload css once loaded, whether supported or not.
*/
( function ( w ) {
     "use strict";
     // rel=preload support test
     if ( !w.loadCSS ) {
          w.loadCSS = function () {};
     }
     // define on the loadCSS obj
     var rp = loadCSS.relpreload = {};
     // rel=preload feature support test
     // runs once and returns a function for compat purposes
     rp.support = ( function () {
          var ret;
          try {
               ret = w.document.createElement( "link" ).relList.supports( "preload" );
          } catch ( e ) {
               ret = false;
          }
          return function () {
               return ret;
          };
     } )();

     // if preload isn't supported, get an asynchronous load by using a non-matching media attribute
     // then change that media back to its intended value on load
     rp.bindMediaToggle = function ( link ) {
          // remember existing media attr for ultimate state, or default to 'all'
          var finalMedia = link.media || "all";

          function enableStylesheet() {
               link.media = finalMedia;
          }

          // bind load handlers to enable media
          if ( link.addEventListener ) {
               link.addEventListener( "load", enableStylesheet );
          } else if ( link.attachEvent ) {
               link.attachEvent( "onload", enableStylesheet );
          }

          // Set rel and non-applicable media type to start an async request
          // note: timeout allows this to happen async to let rendering continue in IE
          setTimeout( function () {
               link.rel = "stylesheet";
               link.media = "only x";
          } );
          // also enable media after 3 seconds,
          // which will catch very old browsers (android 2.x, old firefox) that don't support onload on link
          setTimeout( enableStylesheet, 3000 );
     };

     // loop through link elements in DOM
     rp.poly = function () {
          // double check this to prevent external calls from running
          if ( rp.support() ) {
               return;
          }
          var links = w.document.getElementsByTagName( "link" );
          for ( var i = 0; i < links.length; i++ ) {
               var link = links[ i ];
               // qualify links to those with rel=preload and as=style attrs
               if ( link.rel === "preload" && link.getAttribute( "as" ) === "style" && !link.getAttribute( "data-loadcss" ) ) {
                    // prevent rerunning on link
                    link.setAttribute( "data-loadcss", true );
                    // bind listeners to toggle media back
                    rp.bindMediaToggle( link );
               }
          }
     };

     // if unsupported, run the polyfill
     if ( !rp.support() ) {
          // run once at least
          rp.poly();

          // rerun poly on an interval until onload
          var run = w.setInterval( rp.poly, 500 );
          if ( w.addEventListener ) {
               w.addEventListener( "load", function () {
                    rp.poly();
                    w.clearInterval( run );
               } );
          } else if ( w.attachEvent ) {
               w.attachEvent( "onload", function () {
                    rp.poly();
                    w.clearInterval( run );
               } );
          }
     }

     // commonjs
     if ( typeof exports !== "undefined" ) {
          exports.loadCSS = loadCSS;
     } else {
          w.loadCSS = loadCSS;
     }
}( typeof global !== "undefined" ? global : this ) );

if ( !Date.now ) {
     Date.now = function now() {
          return new Date().getTime();
     };
}

/*https://gist.github.com/jonathantneal/3748027*/
!window.addEventListener && (function (WindowPrototype, DocumentPrototype, ElementPrototype, addEventListener, removeEventListener, dispatchEvent, registry) {
	WindowPrototype[addEventListener] = DocumentPrototype[addEventListener] = ElementPrototype[addEventListener] = function (type, listener) {
		var target = this;

		registry.unshift([target, type, listener, function (event) {
			event.currentTarget = target;
			event.preventDefault = function () { event.returnValue = false };
			event.stopPropagation = function () { event.cancelBubble = true };
			event.target = event.srcElement || target;

			listener.call(target, event);
		}]);

		this.attachEvent("on" + type, registry[0][3]);
	};

	WindowPrototype[removeEventListener] = DocumentPrototype[removeEventListener] = ElementPrototype[removeEventListener] = function (type, listener) {
		for (var index = 0, register; register = registry[index]; ++index) {
			if (register[0] == this && register[1] == type && register[2] == listener) {
				return this.detachEvent("on" + type, registry.splice(index, 1)[0][3]);
			}
		}
	};

	WindowPrototype[dispatchEvent] = DocumentPrototype[dispatchEvent] = ElementPrototype[dispatchEvent] = function (eventObject) {
		return this.fireEvent("on" + eventObject.type, eventObject);
	};
})(Window.prototype, HTMLDocument.prototype, Element.prototype, "addEventListener", "removeEventListener", "dispatchEvent", []);

/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create */
if ( typeof Object.create !== "function" ) {
     Object.create = function ( proto, propertiesObject ) {
          'use strict';
          if ( typeof proto !== 'object' && typeof proto !== 'function' ) {
               throw new TypeError( 'Object prototype may only be an Object: ' + proto );
          } else if ( proto === null ) {
               throw new Error( "This browser's implementation of Object.create is a shim and doesn't support 'null' as the first argument." );
          }

          if ( typeof propertiesObject != 'undefined' ) {
               throw new Error( "This browser's implementation of Object.create is a shim and doesn't support a second argument." );
          }

          function F() {}
          F.prototype = proto;

          return new F();
     };
}

/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys */
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if ( !Object.keys ) {
     Object.keys = ( function () {
          'use strict';
          var hasOwnProperty = Object.prototype.hasOwnProperty,
               hasDontEnumBug = !( { toString: null } ).propertyIsEnumerable( 'toString' ),
               dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
               dontEnumsLength = dontEnums.length;

          return function ( obj ) {
               if ( typeof obj !== 'function' && ( typeof obj !== 'object' || obj === null ) ) {
                    throw new TypeError( 'Object.keys called on non-object' );
               }

               var result = [],
                    prop, i;

               for ( prop in obj ) {
                    if ( hasOwnProperty.call( obj, prop ) ) {
                         result.push( prop );
                    }
               }

               if ( hasDontEnumBug ) {
                    for ( i = 0; i < dontEnumsLength; i++ ) {
                         if ( hasOwnProperty.call( obj, dontEnums[ i ] ) ) {
                              result.push( dontEnums[ i ] );
                         }
                    }
               }
               return result;
          };
     }() );
}

/*
 * object.isEmpty polyfill
 *
 * Checks if an array contains some elements
 * @return { Boolean } true: the array is empty
 */
if (!Object.prototype.isEmpty) {
	Object.defineProperty(Object.prototype, "isEmpty", {
		enumerable: false,
		configurable: true,
		writable: true,
		value: function () {
					for (var key in this) {
						if (this.hasOwnProperty(key))
							return false;
					}
					return true;
		}
	});
}
/*
 * object.watch polyfill
 */
if ( !Object.prototype.watch ) {
     Object.defineProperty( Object.prototype, "watch", {
          enumerable: false,
          configurable: true,
          writable: false,
          value: function ( prop, handler ) {
               var oldval = this[ prop ],
                    newval = oldval,
                    getter = function () {
                         return newval;
                    },
                    setter = function ( val ) {
                         oldval = newval;
                         return newval = handler.call( this, prop, oldval, val );
                    };

               if ( delete this[ prop ] ) {
                    Object.defineProperty( this, prop, { get: getter, set: setter, enumerable: true, configurable: true } );
               }
          }
     } );
}

/*
 * object.unwatch polyfill
 */
if ( !Object.prototype.unwatch ) {
     Object.defineProperty( Object.prototype, "unwatch", {
          enumerable: false,
          configurable: true,
          writable: false,
          value: function ( prop ) {
               var val = this[ prop ];
               delete this[ prop ];
               this[ prop ] = val;
          }
     } );
}

if ( 'serviceWorker' in navigator ) {

    if ( !Cache.prototype.add ) {
        Cache.prototype.add = function add(request) {
            return this.addAll([request]);
        };
    }

    if (!Cache.prototype.addAll) {
        Cache.prototype.addAll = function addAll(requests) {
            var cache = this;

            // Since DOMExceptions are not constructable:
            function NetworkError(message) {
                this.name = 'NetworkError';
                this.code = 19;
                this.message = message;
            }
            NetworkError.prototype = Object.create(Error.prototype);

            return Promise.resolve().then(function () {
                if (arguments.length < 1) throw new TypeError();

                // Simulate sequence<(Request or USVString)> binding:
                var sequence = [];

                requests = requests.map(function (request) {
                    if (request instanceof Request) {
                        return request;
                    } else {
                        return String(request); // may throw TypeError
                    }
                });

                return Promise.all(
                    requests.map(function (request) {
                        if (typeof request === 'string') {
                            request = new Request(request);
                        }

                        var scheme = new URL(request.url).protocol;

                        if (scheme !== 'http:' && scheme !== 'https:') {
                            throw new NetworkError("Invalid scheme");
                        }

                        return fetch(request.clone());
                    })
                );
            }).then(function (responses) {
                // TODO: check that requests don't overwrite one another
                // (don't think this is possible to polyfill due to opaque responses)
                return Promise.all(
                    responses.map(function (response, i) {
                        return cache.put(requests[i], response);
                    })
                );
            }).then(function () {
                return undefined;
            });
        };
    }

    if (!CacheStorage.prototype.match) {
        // This is probably vulnerable to race conditions (removing caches etc)
        CacheStorage.prototype.match = function match(request, opts) {
            var caches = this;

            return this.keys().then(function (cacheNames) {
                var match;

                return cacheNames.reduce(function (chain, cacheName) {
                    return chain.then(function () {
                        return match || caches.open(cacheName).then(function (cache) {
                            return cache.match(request, opts);
                        }).then(function (response) {
                            match = response;
                            return match;
                        });
                    });
                }, Promise.resolve());
            });
        };
    }
    if (!Cache.prototype.add) {
        Cache.prototype.add = function add(request) {
            return this.addAll([request]);
        };
    }

    if (!Cache.prototype.addAll) {
        Cache.prototype.addAll = function addAll(requests) {
            var cache = this;

            // Since DOMExceptions are not constructable:
            function NetworkError(message) {
                this.name = 'NetworkError';
                this.code = 19;
                this.message = message;
            }
            NetworkError.prototype = Object.create(Error.prototype);

            return Promise.resolve().then(function () {
                if (arguments.length < 1) throw new TypeError();

                // Simulate sequence<(Request or USVString)> binding:
                var sequence = [];

                requests = requests.map(function (request) {
                    if (request instanceof Request) {
                        return request;
                    } else {
                        return String(request); // may throw TypeError
                    }
                });

                return Promise.all(
                    requests.map(function (request) {
                        if (typeof request === 'string') {
                            request = new Request(request);
                        }

                        var scheme = new URL(request.url).protocol;

                        if (scheme !== 'http:' && scheme !== 'https:') {
                            throw new NetworkError("Invalid scheme");
                        }

                        return fetch(request.clone());
                    })
                );
            }).then(function (responses) {
                // TODO: check that requests don't overwrite one another
                // (don't think this is possible to polyfill due to opaque responses)
                return Promise.all(
                    responses.map(function (response, i) {
                        return cache.put(requests[i], response);
                    })
                );
            }).then(function () {
                return undefined;
            });
        };
    }

    if (!CacheStorage.prototype.match) {
        // This is probably vulnerable to race conditions (removing caches etc)
        CacheStorage.prototype.match = function match(request, opts) {
            var caches = this;

            return this.keys().then(function (cacheNames) {
                var match;

                return cacheNames.reduce(function (chain, cacheName) {
                    return chain.then(function () {
                        return match || caches.open(cacheName).then(function (cache) {
                            return cache.match(request, opts);
                        }).then(function (response) {
                            match = response;
                            return match;
                        });
                    });
                }, Promise.resolve());
            });
        };
    }
    if (!Cache.prototype.add) {
        Cache.prototype.add = function add(request) {
            return this.addAll([request]);
        };
    }

    if (!Cache.prototype.addAll) {
        Cache.prototype.addAll = function addAll(requests) {
            var cache = this;

            // Since DOMExceptions are not constructable:
            function NetworkError(message) {
                this.name = 'NetworkError';
                this.code = 19;
                this.message = message;
            }
            NetworkError.prototype = Object.create(Error.prototype);

            return Promise.resolve().then(function () {
                if (arguments.length < 1) throw new TypeError();

                // Simulate sequence<(Request or USVString)> binding:
                var sequence = [];

                requests = requests.map(function (request) {
                    if (request instanceof Request) {
                        return request;
                    } else {
                        return String(request); // may throw TypeError
                    }
                });

                return Promise.all(
                    requests.map(function (request) {
                        if (typeof request === 'string') {
                            request = new Request(request);
                        }

                        var scheme = new URL(request.url).protocol;

                        if (scheme !== 'http:' && scheme !== 'https:') {
                            throw new NetworkError("Invalid scheme");
                        }

                        return fetch(request.clone());
                    })
                );
            }).then(function (responses) {
                // TODO: check that requests don't overwrite one another
                // (don't think this is possible to polyfill due to opaque responses)
                return Promise.all(
                    responses.map(function (response, i) {
                        return cache.put(requests[i], response);
                    })
                );
            }).then(function () {
                return undefined;
            });
        };
    }

    if (!CacheStorage.prototype.match) {
        // This is probably vulnerable to race conditions (removing caches etc)
        CacheStorage.prototype.match = function match(request, opts) {
            var caches = this;

            return this.keys().then(function (cacheNames) {
                var match;

                return cacheNames.reduce(function (chain, cacheName) {
                    return chain.then(function () {
                        return match || caches.open(cacheName).then(function (cache) {
                            return cache.match(request, opts);
                        }).then(function (response) {
                            match = response;
                            return match;
                        });
                    });
                }, Promise.resolve());
            });
        };
    }
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
if ( !String.prototype.includes ) {
     String.prototype.includes = function ( search, start ) {
          'use strict';
          if ( typeof start !== 'number' ) start = 0;
          return !( start + search.length > this.length ) ? this.indexOf( search, start ) !== -1 : false;
     };
}

/* https://tosbourn.com/a-fix-for-window-location-origin-in-internet-explorer/  */
if (!window.location.origin) {
    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}
/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license */

window.matchMedia || (window.matchMedia = function() {
    "use strict";

    // For browsers that support matchMedium api such as IE 9 and webkit
    var styleMedia = (window.styleMedia || window.media);

    // For those that don't support matchMedium
    if (!styleMedia) {
        var style       = document.createElement('style'),
            script      = document.getElementsByTagName('script')[0],
            info        = null;

        style.type  = 'text/css';
        style.id    = 'matchmediajs-test';

        if (!script) {
          document.head.appendChild(style);
        } else {
          script.parentNode.insertBefore(style, script);
        }

        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
        info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

        styleMedia = {
            matchMedium: function(media) {
                var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                if (style.styleSheet) {
                    style.styleSheet.cssText = text;
                } else {
                    style.textContent = text;
                }

                // Test if media query is true or false
                return info.width === '1px';
            }
        };
    }

    return function(media) {
        return {
            matches: styleMedia.matchMedium(media || 'all'),
            media: media || 'all'
        };
    };
}());

/*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. MIT license */
(function(){
    // Bail out for browsers that have addListener support
    if (window.matchMedia && window.matchMedia('all').addListener) {
        return false;
    }

    var localMatchMedia = window.matchMedia,
        hasMediaQueries = localMatchMedia('only all').matches,
        isListening     = false,
        timeoutID       = 0,    // setTimeout for debouncing 'handleChange'
        queries         = [],   // Contains each 'mql' and associated 'listeners' if 'addListener' is used
        handleChange    = function(evt) {
            // Debounce
            clearTimeout(timeoutID);

            timeoutID = setTimeout(function() {
                for (var i = 0, il = queries.length; i < il; i++) {
                    var mql         = queries[i].mql,
                        listeners   = queries[i].listeners || [],
                        matches     = localMatchMedia(mql.media).matches;

                    // Update mql.matches value and call listeners
                    // Fire listeners only if transitioning to or from matched state
                    if (matches !== mql.matches) {
                        mql.matches = matches;

                        for (var j = 0, jl = listeners.length; j < jl; j++) {
                            listeners[j].call(window, mql);
                        }
                    }
                }
            }, 30);
        };

    window.matchMedia = function(media) {
        var mql         = localMatchMedia(media),
            listeners   = [],
            index       = 0;

        mql.addListener = function(listener) {
            // Changes would not occur to css media type so return now (Affects IE <= 8)
            if (!hasMediaQueries) {
                return;
            }

            // Set up 'resize' listener for browsers that support CSS3 media queries (Not for IE <= 8)
            // There should only ever be 1 resize listener running for performance
            if (!isListening) {
                isListening = true;
                window.addEventListener('resize', handleChange, true);
            }

            // Push object only if it has not been pushed already
            if (index === 0) {
                index = queries.push({
                    mql         : mql,
                    listeners   : listeners
                });
            }

            listeners.push(listener);
        };

        mql.removeListener = function(listener) {
            for (var i = 0, il = listeners.length; i < il; i++){
                if (listeners[i] === listener){
                    listeners.splice(i, 1);
                }
            }
        };

        return mql;
    };
}());
